import React from 'react';

import { useRecordContext, TextField } from 'react-admin';

import { Grid, Box, Typography } from '@mui/material';

import { get } from 'lodash';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import { TextQuestionParameters } from '../../questionParameters';

const CONTENT = {
  [languages.SV]: 'Personnumber',
  [languages.EN]: 'Personal number',
  [languages.DE]: 'Personenkennnummer',
};

const ValueField = () => {
  const record = useRecordContext();

  const value = get(record, 'value');
  const sx = get(record, 'sx', {});

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const PersonalNumber = ({
  source,
  extraParameters,
}: {
  source?: string;
  extraParameters?: TextQuestionParameters;
}) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? CONTENT[language]}
      source={source ?? 'personalNumber'}
      datapoint={null}
      identificationInfo={undefined}
    >
      <ValueField />
    </Answer>
  );
};

PersonalNumber.Nested = ({ source, extraParameters }: {
  source?: string;
  extraParameters?: TextQuestionParameters;
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const record = useRecordContext();
  const sx = get(record, 'sx', {});

  const language = record?.language as Languages;

  return (
    <Grid
      size={{
        xs: 12,
        md: 3,
      }}
    >
      <Box display="flex" flexDirection="column">
        <Typography variant="label">{extraParameters?.label ?? CONTENT[language]}</Typography>
        <TextField
          source={source ?? 'personalNumber'}
          emptyText="-"
          sx={sx}
        />
      </Box>
    </Grid>
  );
};

PersonalNumber.ValueField = ValueField;

export default PersonalNumber;
